<template>
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">搜索</Button>
			<Button type="primary" icon="md-cloud-upload" style="margin-left: 20px;"
				@click="clickImport">导入Excel</Button>
			<Button type="primary" style="margin-left: 20px;" @click="downTemplate">下载模版</Button>
			<Button type="primary" style="margin-left: 20px;" @click="clickBatchDelete">批量删除</Button>
		</div>

		<Table ref="table" size="large" border stripe :loading="loading" :columns="columns1" :data="data1"
			@on-selection-change="onSelectionChange" style="margin: 20px 0;">
			<template slot-scope="{ row, index }" slot="deparams">
				<div style="display: flex;justify-content: space-around;">
					<Button type="primary" @click="clickUpdate(row)" style="padding: 5px 5px 6px;">编辑</Button>
					<Button type="primary" @click="clickDelete(row)" style="padding: 5px 5px 6px;">删除</Button>
				</div>
			</template>
		</Table>
		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />

		<Upload ref="upload" name="file" :action="importUrl" :on-success="onUploadSuccess" :format="['xlsx','xls']"
			:show-upload-list="false" style="display: none;">
			<Button />
		</Upload>

		<Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
				<Icon type="md-create" />
				<span>搜索</span>
			</p>
			<div style="text-align:center">
				<CheckboxGroup v-model="selectedCondition" class="check_grop">
					<div>
						<Checkbox label="meterId">
							<span>表号</span>
						</Checkbox>
						<Input v-model="meterId" placeholder="请输入表号" style="width: 200px" />
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
			</div>
		</Modal>

		<Modal title="Title" v-model="showDialog" class="common_update_dialog">
			<div slot="header">
				<span>{{showTitle}}</span>
			</div>
			<div>
				<span>名称</span>
				<Input :readonly="showType=='show'" v-model="currentRow.name" />
			</div>
			<div>
				<span>公司编号</span>
				<Input :readonly="showType=='show'" v-model="currentRow.companyNum" />
			</div>
			<div>
				<span>启动日期</span>
				<DatePicker :readonly="showType=='show'" v-model="currentRow.startLadderTimestamp"
					format="yyyy-MM-dd HH:mm:ss" @on-change="onStartLadderTimestampChange" />
			</div>
			<div>
				<span>结束日期</span>
				<DatePicker :readonly="showType=='show'" v-model="currentRow.endLadderTimestamp"
					format="yyyy-MM-dd HH:mm:ss" @on-change="onEndLadderTimestampChange" />
			</div>
			<div>
				<span>阶梯数</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder" type="number" />
			</div>
			<div>
				<span>计费周期字</span>
				<Input :readonly="showType=='show'" v-model="currentRow.cycle" type="number" />
			</div>
			<div>
				<span>开始日期</span>
				<DatePicker :readonly="showType=='show'" v-model="currentRow.startChargingTimestamp"
					format="yyyy-MM-dd HH:mm:ss" @on-change="onStartChargingTimestampChange" />
			</div>
			<div>
				<span>结束日期/天数</span>
				<Input :readonly="showType=='show'" v-model="currentRow.endCharging" />
			</div>
			<div>
				<span>第一阶梯用量</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder1Total" type="number" />
			</div>
			<div>
				<span>第一阶梯单价</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder1Price" type="number" />
			</div>
			<div>
				<span>第二阶梯用量</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder2Total" type="number" />
			</div>
			<div>
				<span>第二阶梯单价</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder2Price" type="number" />
			</div>
			<div>
				<span>第三阶梯用量</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder3Total" type="number" />
			</div>
			<div>
				<span>第三阶梯单价</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder3Price" type="number" />
			</div>
			<div>
				<span>第四阶梯用量</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder4Total" type="number" />
			</div>
			<div>
				<span>第四阶梯单价</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder4Price" type="number" />
			</div>
			<div>
				<span>第五阶梯用量</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder5Total" type="number" />
			</div>
			<div>
				<span>第五阶梯单价</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder5Price" type="number" />
			</div>
			<div>
				<span>第六阶梯用量</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder6Total" type="number" />
			</div>
			<div>
				<span>第六阶梯单价</span>
				<Input :readonly="showType=='show'" v-model="currentRow.ladder6Price" type="number" />
			</div>
			<div v-if="showType=='show'">
				<span>创建时间</span>
				<Input readonly v-model="currentRow.createTime" />
			</div>
			<div slot="footer">
				<Button v-if="showType=='update'" :loading="submitLoading" type="info" size="large" long
					@click="submitUpdate">立即提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		name: "valuation_manage",
		data() {
			let that = this;
			return {
				columns1: [{
						type: "selection",
						width: 50,
						align: "center"
					},
					{
						title: "编号",
						width: 100,
						key: "id",
						align: "center"
					},
					{
						title: "公司编号",
						width: 150,
						key: "companyNum",
						align: "center"
					},
					{
						title: "名称",
						width: 200,
						key: "name",
						align: "center"
					},
					{
						title: "启动日期",
						width: 200,
						key: "startLadderTimestamp",
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								global.dateFtt(
									"yyyy-MM-dd hh:mm:ss",
									new Date(params.row.startLadderTimestamp)
								)
							);
						}
					},
					{
						title: "结束日期",
						width: 200,
						key: "endLadderTimestamp",
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								global.dateFtt(
									"yyyy-MM-dd hh:mm:ss",
									new Date(params.row.endLadderTimestamp)
								)
							);
						}
					},
					{
						title: "阶梯数",
						width: 150,
						key: "ladder",
						align: "center"
					},
					{
						title: "计费周期字",
						width: 150,
						key: "cycle",
						align: "center"
					},
					{
						title: "开始日期",
						width: 200,
						key: "startChargingTimestamp",
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								global.dateFtt(
									"yyyy-MM-dd hh:mm:ss",
									new Date(params.row.startChargingTimestamp)
								)
							);
						}
					},
					{
						title: "结束日期/天数",
						width: 200,
						key: "endCharging",
						align: "center"
					},
					{
						title: "第一阶梯用量",
						width: 100,
						key: "ladder1Total",
						align: "center"
					},
					{
						title: "第一阶梯单价",
						width: 100,
						key: "ladder1Price",
						align: "center"
					},
					{
						title: "第二阶梯用量",
						width: 100,
						key: "ladder2Total",
						align: "center"
					},
					{
						title: "第二阶梯单价",
						width: 100,
						key: "ladder2Price",
						align: "center"
					},
					{
						title: "第三阶梯用量",
						width: 100,
						key: "ladder3Total",
						align: "center"
					},
					{
						title: "第三阶梯单价",
						width: 100,
						key: "ladder3Price",
						align: "center"
					},
					{
						title: "第四阶梯用量",
						width: 100,
						key: "ladder4Total",
						align: "center"
					},
					{
						title: "第四阶梯单价",
						width: 100,
						key: "ladder4Price",
						align: "center"
					},
					{
						title: "第五阶梯用量",
						width: 100,
						key: "ladder5Total",
						align: "center"
					},
					{
						title: "第五阶梯单价",
						width: 100,
						key: "ladder5Price",
						align: "center"
					},
					{
						title: "第六阶梯用量",
						width: 100,
						key: "ladder6Total",
						align: "center"
					},
					{
						title: "第六阶梯单价",
						width: 100,
						key: "ladder6Price",
						align: "center"
					},
					{
						title: "操作",
						fixed: 'right',
						width: 150,
						slot: "deparams",
						align: "center"
					}
				],
				meterId: '',
				importUrl: '/api/meter/admin/valuation/imports',
				templateUrl: 'http://www.cnzhuocheng.cn/' + encodeURIComponent('计价方案导入模板.xls'),
				selection: [],
				currentRow: {},
				data1: [],
				loading: false,
				submitLoading: false,
				modal8: false,
				currentPage: 1,
				totalRows: 0,
				pageSize: 30,
				selectedCondition: [],
				requestBody: {},
				showType: 'show',
				showTitle: '详情',
				showDialog: false,
			};
		},
		created() {
			this.getDataList();
		},
		mounted() {

		},
		methods: {
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			clickImport() {
				this.$refs.upload.$el.children[0].children[0].dispatchEvent(new MouseEvent('click'));
			},
			onUploadSuccess(response, file, fileList) {
				if (!response.success) {
					this.$Notice.error({
						title: "异常",
						desc: response.msg
					});
					this.getDataList();
					return;
				}

				this.$Notice.success({
					title: "提示",
					desc: "导入" + response.data.count + "条，" +
						'成功' + response.data.successCount +
						'条，失败' + response.data.failureCount +
						'条，忽略' + response.data.skipCount + '条'
				});
				this.getDataList();
			},
			downTemplate() {
				window.location.href = this.templateUrl + "?" + new Date();
			},
			clickBatchDelete() {
				let that = this;
				if (that.selection.length == 0) {
					that.$Notice.info({
						title: "提示",
						desc: "请选择数据"
					});
					return;
				}

				let idArray = [];
				for (let i in that.selection) {
					let id = that.selection[i].id;
					idArray.push(id);
				}
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认批量删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/valuation/batchDelete",
							type: "post",
							data: {
								idJoin: idArray.join(',')
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			onSelectionChange(selection) {
				this.selection = selection;
			},
			onStartLadderTimestampChange(date) {
				this.currentRow.startLadderTimestamp = date;
			},
			onEndLadderTimestampChange(date) {
				this.currentRow.endLadderTimestamp = date;
			},
			onStartChargingTimestampChange(date) {
				this.currentRow.startChargingTimestamp = date;
			},
			clickUpdate(row) {
				this.currentRow = row;
				this.showType = 'update';
				this.showTitle = '编辑';
				this.showDialog = true;
			},
			submitUpdate() {
				let that = this;
				that.submitLoading = true;
				delete that.currentRow.createTime;
				delete that.currentRow.activateTime;
				$.ajax({
					url: "/api/meter/admin/valuation/update",
					type: "post",
					data: that.currentRow,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "提交成功"
						});
						that.showDialog = false;
						that.getDataList();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			clickDelete(row) {
				let that = this;
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/valuation/delete",
							type: "post",
							data: {
								id: row.id
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									that.getDataList();
									return;
								}

								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.currentPage = index;
				this.getDataList();
			},
			// 按条件检索点击事件
			searchByCondition() {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.modal8 = false;
				this.currentPage = 1;
				this.getDataList();
			},
			getDataList() {
				var that = this;
				that.loading = true;
				if (localStorage.getItem("isAdmin") != "true") {
				that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
    			}
				$.ajax({
					url: "/api/meter/admin/valuation/getPage?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize +
						"&paging=true",
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.selection = [];
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			}
		}
	};
</script>

<style>
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}

	.check_grop div {
		margin-bottom: 1px;
	}
</style>
